/**
 * Converts an object with camelCase keys to a new object with dasherized keys.
 * Undefined values are omitted from the result.
 * @param obj - The object to convert.
 * @returns A new object with dasherized keys.
 */
export function toDasherized(obj: Record<string, unknown>): Record<string, unknown> {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (value !== undefined) {
        const dasherizedKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
        acc[dasherizedKey] = value;
      }
      return acc;
    },
    {} as Record<string, unknown>
  );
}
